import React from 'react'
import PropTypes from 'prop-types'
import Paper from '@material-ui/core/Paper'
import { withStyles} from '@material-ui/core/styles'
import {
  Grid, Table, TableHeaderRow
} from '@devexpress/dx-react-grid-material-ui'

const styles = {
  customCell: {
    whiteSpace: "normal",
    wordWrap: "break-word"
  }
}

const CustomTableCellBase = ({ classes, ...restProps }) => (
  <Table.Cell className={classes.customCell} {...restProps} />
)

const CustomTableBase = ({ style, ...restProps }) => (
  <Table.Table
    style={{
      ...style,
      minWidth: 0
    }}
    {...restProps}
  />
)

const CustomTableCell = withStyles(styles)(CustomTableCellBase);
const CustomTable = withStyles(styles)(CustomTableBase);

class PTZTable extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      columns: [
        { name: "actionColumn", title: "Pan, Tilt & Zoom" },
        { name: "descriptionColumn", title: "Description" }
      ],
      rows: [
        { actionColumn: 'Avoid alarms while moving', descriptionColumn: 'In most cases it is unwanted, that the pan & tilt movement of your camera causes a [Motion Detection](/Web_User_Interface/720p_Series/Alarm/Areas/). But if you want to be notified whenever your camera is moved, just check this box.' },
        { actionColumn: 'Activate adjustment movement', descriptionColumn: 'Activate or deactivate the camera PTZ calibration run at boot-up. Please be aware, that the [Saved Positions](/Web_User_Interface/1080p_Series/Live_Video/) for your camera will no longer be available, when the calibration is deactivated.' },
        { actionColumn: 'Reverse horizontal movement', descriptionColumn: 'Reverse left/right pan when your camera is installed upside down.' },
        { actionColumn: 'Reverse vertical movement', descriptionColumn: 'Reverse up/down tilt when your camera is installed upside down.' },
        { actionColumn: 'Enable Start-Up Position / Action', descriptionColumn: 'Activate a position / action the camera should move to / do after a the start-up procedure.' },
        { actionColumn: 'Select Start-Up Position / Action', descriptionColumn: 'Select a saved position your camera should move to after boot up or activate the vertical scan or Tour Function' },
        { actionColumn: 'Enable Alarm Position', descriptionColumn: 'Do you want your camera to point in a specific direction when an alarm is triggered? Activate this function here.' },
        { actionColumn: 'Select Alarm Position', descriptionColumn: 'Set the position you want your camera to move to in case of an alarm here (see above).' },
        { actionColumn: 'Move to Park Position', descriptionColumn: 'Do you want your camera to always point in a specific direction by default? Activate the park position to let your camera go back to this position automatically after it was moved.' },
        { actionColumn: 'Select Park Position', descriptionColumn: 'Set the park position here (see above).' },
        { actionColumn: 'Move after X Seconds', descriptionColumn: 'How long should the camera wait before returning to the Park Positions?' }
      ]
    };
  }
  render() {
    const { rows, columns } = this.state;

    return (
      <Paper style={{display: 'inline-block', maxWidth: '915px'}}>
        <Grid rows={rows} columns={columns}>
          <Table tableComponent={CustomTable} cellComponent={CustomTableCell} />
          <TableHeaderRow />
        </Grid>
      </Paper>
    );
  }
}

PTZTable.propTypes = {
  classes: PropTypes.object.isRequired,
}


export default withStyles(styles)(PTZTable)